import { axiosInstance } from './axios';
import { AxiosPromise } from 'axios';
import { Address } from '../@types';

export function getAddress(): AxiosPromise<Address[]> {
  return axiosInstance.get('/address');
}
